export const isObj = value =>
  value != null && typeof value === 'object' && !Array.isArray(value);
